import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Configure, Index } from 'react-instantsearch';
import { ALGOLIA_INDEX_NAME } from 'commons/constants';
import useProductListingPageContext from 'data-hooks/useProductListingPageContext';
import removeQuickshipFacet from '../helpers/removeQuickshipFacet';
import { CATEGORY_INDEX_MAPPING, SearchCount } from '../../commons/helpers';
import ProductSearchCount from './ProductSearchCount';
const SearchDesktopSidebarHeader = t0 => {
  const $ = _c(43);
  const {
    index,
    onIndexChange,
    searchState
  } = t0;
  const isProductsSearch = index === ALGOLIA_INDEX_NAME.PRODUCTS;
  const {
    loading
  } = useProductListingPageContext() ?? {};
  searchState.configure?.facetFilters;
  const t1 = searchState.configure?.facetFilters;
  let t2;
  if ($[0] !== t1) {
    t2 = removeQuickshipFacet(t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const sanitizedFacetFilters = t2;
  if (isProductsSearch && loading) {
    return null;
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="text-base font-bold text-gray px-0 py-4">Refine by:</div>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = ["*"];
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = ["item_availability<2", "visibility>0", "visibility<4"];
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== searchState.configure.facetFilters) {
    t6 = <Configure facets={t4} facetFilters={searchState.configure.facetFilters} numericFilters={t5} getRankingInfo={true} />;
    $[5] = searchState.configure.facetFilters;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== index || $[8] !== onIndexChange) {
    t7 = <ProductSearchCount title="Products" id={CATEGORY_INDEX_MAPPING.products} selectedOption={index} indexClick={onIndexChange} />;
    $[7] = index;
    $[8] = onIndexChange;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t6 || $[11] !== t7) {
    t8 = <Index indexName={ALGOLIA_INDEX_NAME.PRODUCTS}>{t6}{t7}</Index>;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t10;
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = ["fk_store_id=1"];
    t10 = ["is_searchable:1"];
    $[13] = t10;
    $[14] = t9;
  } else {
    t10 = $[13];
    t9 = $[14];
  }
  let t11;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Index indexName={ALGOLIA_INDEX_NAME.CATEGORIES}><Configure numericFilters={t9} facetFilters={t10} getRankingInfo={true} attributesToRetrieve={["objectID", "category_name", "category_sef_url", "url"]} /></Index>;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = ["*"];
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== sanitizedFacetFilters) {
    t13 = <Configure facets={t12} numericFilters="" facetFilters={sanitizedFacetFilters} />;
    $[17] = sanitizedFacetFilters;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== index || $[20] !== onIndexChange) {
    t14 = <SearchCount title="Customer Photos" id={CATEGORY_INDEX_MAPPING["customer photos"]} selectedOption={index} indexClick={onIndexChange} />;
    $[19] = index;
    $[20] = onIndexChange;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== t13 || $[23] !== t14) {
    t15 = <Index indexName={ALGOLIA_INDEX_NAME.CUSTOMER_PHOTOS}>{t13}{t14}</Index>;
    $[22] = t13;
    $[23] = t14;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Configure facets={["*"]} numericFilters="" facetFilters="" />;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== index || $[27] !== onIndexChange) {
    t17 = <Index indexName={ALGOLIA_INDEX_NAME.REVIEWS}>{t16}<SearchCount title="Reviews" id={CATEGORY_INDEX_MAPPING.reviews} selectedOption={index} indexClick={onIndexChange} /></Index>;
    $[26] = index;
    $[27] = onIndexChange;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <Configure numericFilters={["is_active=1", "show_in_search=1", "fk_store_id=1"]} />;
    $[29] = t18;
  } else {
    t18 = $[29];
  }
  let t19;
  if ($[30] !== index || $[31] !== onIndexChange) {
    t19 = <Index indexName={ALGOLIA_INDEX_NAME.STATIC_PAGES}>{t18}<SearchCount title="Pages" id={CATEGORY_INDEX_MAPPING.pages} selectedOption={index} indexClick={onIndexChange} /></Index>;
    $[30] = index;
    $[31] = onIndexChange;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  let t20;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = ["*"];
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = ["item_availability<2", "visibility>0", "visibility<4"];
    $[34] = t21;
  } else {
    t21 = $[34];
  }
  let t22;
  if ($[35] !== searchState.configure.facetFilters) {
    t22 = <Index indexName={ALGOLIA_INDEX_NAME.PRODUCTS}><Configure facets={t20} facetFilters={searchState.configure.facetFilters} numericFilters={t21} getRankingInfo={true} /></Index>;
    $[35] = searchState.configure.facetFilters;
    $[36] = t22;
  } else {
    t22 = $[36];
  }
  let t23;
  if ($[37] !== t15 || $[38] !== t17 || $[39] !== t19 || $[40] !== t22 || $[41] !== t8) {
    t23 = <div className="lg:pb-8 lg:min-w-[257px] lg:pr-8 lg:w-[257px] pr-6"><div className="mb-[25px]">{t3}<div className="text-base text-gray font-normal">{t8}{t11}{t15}{t17}{t19}{t22}</div></div></div>;
    $[37] = t15;
    $[38] = t17;
    $[39] = t19;
    $[40] = t22;
    $[41] = t8;
    $[42] = t23;
  } else {
    t23 = $[42];
  }
  return t23;
};
SearchDesktopSidebarHeader.propTypes = {
  searchState: PropTypes.shape({
    query: PropTypes.string,
    configure: {
      facetFilters: PropTypes.string,
      facets: PropTypes.array
    },
    hitsPerPage: 12,
    page: 1
  }),
  index: PropTypes.string,
  onIndexChange: PropTypes.func
};
export default SearchDesktopSidebarHeader;